import { render, staticRenderFns } from "./ClinicInvoices.vue?vue&type=template&id=2e7cbc25&scoped=true"
import script from "./ClinicInvoices.vue?vue&type=script&lang=js"
export * from "./ClinicInvoices.vue?vue&type=script&lang=js"
import style0 from "./ClinicInvoices.vue?vue&type=style&index=0&id=2e7cbc25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7cbc25",
  null
  
)

export default component.exports